import { CALL_DIRECTIONS, CALL_STATUSES } from "constants/suno-comms";
import { format } from "date-fns";
import { type CallLog } from "services/suno-comms/types/call-log.type";
import { type TranscriptionObject } from "services/suno-comms/types/transcription-object.type";
import { type Clinic } from "services/types/clinics.type";
import { formatPhoneNumber } from "utils/common";

export const formatCallNumber = (number: string | undefined) => {
  if (!number) return "";
  number = number.replace("+1", "");
  number = number.replace(/-/g, "");
  return number;
};

export const formatCallLog = (callLog: CallLog, clinic?: Clinic) => {
  const {
    date,
    duration,
    external_number,
    internal_number,
    direction,
    status,
    created_at,
    updated_at,
    transcription,
    discarded_at,
  } = callLog || {};

  let transcriptionObject: TranscriptionObject | undefined = undefined;

  if (transcription && transcription.includes("{")) {
    try {
      const parsed = JSON.parse(transcription);
      if (Array.isArray(parsed)) {
        transcriptionObject = {
          segments: parsed,
        };
      } else {
        transcriptionObject = parsed;
      }
    } catch {}
  }

  return {
    ...callLog,
    date: date ? format(new Date(date), "MM/dd/yyyy (h:mmaaa)") : "",
    transcriptionObject,
    external_number: external_number ? formatPhoneNumber(external_number) : "",
    internal_number: internal_number ? formatPhoneNumber(internal_number) : "",
    direction: CALL_DIRECTIONS.getFromCode(direction),
    status: CALL_STATUSES.getFromCode(status),
    duration: formatCallLogDuration(duration),
    created_at: created_at
      ? format(new Date(created_at), "MM/dd/yyyy (h:mmaaa)")
      : "",
    updated_at: updated_at
      ? format(new Date(updated_at), "MM/dd/yyyy (h:mmaaa)")
      : "",
    discarded_at: discarded_at
      ? format(new Date(discarded_at), "MM/dd/yyyy (h:mmaaa)")
      : "",
  };
};

export function formatCallLogDuration(duration: string | null): string {
  if (!duration) {
    return "";
  }

  const regex = /PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/;
  const match = duration.match(regex);
  if (match) {
    const hours = match[1] ? parseInt(match[1], 10) : 0;
    const minutes = match[2] ? parseInt(match[2], 10) : 0;
    const seconds = match[3] ? parseInt(match[3], 10) : 0;

    const parts: string[] = [];
    if (hours > 0) {
      parts.push(`${hours}h`);
    }
    if (minutes > 0) {
      parts.push(`${minutes}m`);
    }
    if (seconds > 0) {
      parts.push(`${seconds}s`);
    }

    return parts.join(" ");
  } else {
    return duration;
  }
}
